import { createContentPropTypes } from '../../../helpers/content';

const content = {
	view: 'View',
	favourites: 'Favourite accounts',
	allAccounts: 'All accounts',
	searchPlaceholder: 'Search all accounts',
	favouritesNoFavouritesText:
		"Make it easier to manage your accounts by selecting your favourites from the 'All Accounts' tab",
	addMoreFavourites:
		"Remember you can set up to 30 favourite accounts from the 'All Accounts' tab above. You can always change this order from the more menu.",
	search: 'Search',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
